import { makeStyles, tokens } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';

export const useStyles = makeStyles({
    removePadding: {
        padding: px(0),
    },
    card: {
        borderRadius: tokens.borderRadiusXLarge,
        boxShadow: tokens.shadow2,
        overflow: 'visible',
        width: '100%',
        minWidth: '100%',
        maxWidth: '100%',
    },
    container: {
        display: 'grid',
        gridTemplateRows: 'max-content max-content 1fr',
        height: '100%',
    },
    header: {
        padding: tokens.spacingHorizontalM,
    },
    description: {
        textTransform: 'uppercase',
        fontSize: tokens.fontSizeBase100,
        color: tokens.colorNeutralForeground4,
    },
    action: {
        display: 'flex',
        gap: tokens.spacingHorizontalM,
    },
    hideOverflow: {
        overflow: 'hidden',
    },
});
